import ContentfulProvider from './ContentfulProvider';

export default ContentfulProvider;
